// extracted by mini-css-extract-plugin
export default {"title":"SidePanelAnnouncement_title__enOt+","text":"SidePanelAnnouncement_text__GnFL8","path":"SidePanelAnnouncement_path__ZwYGw","actions":"SidePanelAnnouncement_actions__8P+CL"};